module.exports = __webpack_public_path__ + "img/xpu-ha-beach.17a5dd46.jpg";